import React, { Component } from 'react';

class Modal extends Component {
  render() {
    return (
      <div className="modal">
        <div className="modal-content">
          {/* Modal content goes here */}
        </div>
      </div>
    );
  }
}

export default Modal;